import * as React from 'react';
import type { SVGProps } from 'react';
const SvgGooglePixel6 = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={100} height={100} fill="currentColor" viewBox="0 0 50 50" {...props}>
        <path d="M15 1c-1.645 0-3 1.355-3 3v42c0 1.645 1.355 3 3 3h20c1.645 0 3-1.355 3-3V4c0-1.645-1.355-3-3-3H15zm0 2h20c.565 0 1 .435 1 1v42c0 .565-.435 1-1 1H15c-.565 0-1-.435-1-1V4c0-.565.435-1 1-1zm10 2a1 1 0 0 0 0 2 1 1 0 0 0 0-2z" />
    </svg>
);
export default SvgGooglePixel6;
